import {
  ChipsContainer,
  DefaultQueryParams,
  iframeService,
  isMobile,
  notificationStore,
  parseQuery,
  useTranslation,
} from '@pascal/pascal-core';
import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  freeBetStore,
  platformMessageStore,
  userInfoStore,
} from '@pascal/pascal-core/shared/core/store';
import { useLocation } from 'react-router-dom';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { soundService, soundTypes } from '../../services/SoundService';
import { winningAmountStore } from '../../store/winningAmountStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { turboGameService } from '../../services/TurboGameService';
import { TURBO_GAME_ID } from '../../enums/constants';
import { PlatformErrorCodes } from '../../enums/platformEnums';

export const ChipActionWrapper = observer(() => {
  const {
    reBet,
    reBetAmount,
    quickBets,
    setDouble,
    setUndoBet,
    betsModels,
    selectedChip,
    setBetsModel,
    setSelectedChip,
  } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { setLastWin } = winningAmountStore;
  const { balance } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const t = useTranslation();
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  const handleSelectChips = (chip) => {
    setSelectedChip(chip);
  };

  const handleReBetOrDoubleBet = () => {
    setLastWin(0);
    if (reBet && !betsModels.length && (!isBetsClosed || isTurbo)) {
      if (reBetAmount > balance) {
        !platformMessageStore.isShowAllNotification
          ? iframeService.sendErrorReceived({ errorCode: PlatformErrorCodes.NotEnoughMoney })
          : notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance);
        setTimeout(() => notificationStore.setNotificationType(null), 1000);
        return;
      }
      setBetsModel({ betModel: reBet });
      soundService.play(soundTypes.chip);
    } else {
      setDouble();
    }
  };

  return (
    <div className='chips-wrp'>
      {/* {isTurbo && isMobile() && !isBetsClosed && ( */}
      {/*  <button */}
      {/*    className='shuffle-btn' */}
      {/*    onClick={() => turboGameService.sendShuffleCards()} */}
      {/*    type='button' */}
      {/*  > */}
      {/*    <span className='icon-shuffle-icon' /> */}
      {/*  </button> */}
      {/* )} */}
      <div className={`chips-container ${gameStore.isBetsClosed ? '' : 'active'}`}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`chips-btn ${betsModels.length ? '' : 'disabled'} ${
            isTurbo ? 'chips-bg-left' : ''
          }`}
          type='button'
          onClick={setUndoBet}
        >
          <span className='icon-new-undo' />
        </button>
        <div className='chips-cont-wrp'>
          {isTurbo && isMobile() && !isBetsClosed && (
            <button
              className={`baccarat-deal-button  ${betsModels.length ? 'active' : ''}`}
              onClick={() => turboGameService.sendBet()}
            >
              <span className='baccarat-deal-button-text'>{t('DEAL')}</span>
            </button>
          )}
          {(!isTurbo || !isMobile()) && (
            <ChipsContainer
              isFreeChip={!!activeFreeBet.id}
              selectedChip={selectedChip}
              handleSelectChips={handleSelectChips}
              quickBets={quickBets}
            />
          )}
        </div>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`chips-btn ${
            betsModels.length || (!betsModels.length && reBet) ? '' : 'disabled'
          } ${
            // eslint-disable-next-line no-nested-ternary
            isTurbo ? (betsModels.length ? 'chips-bg-double' : 'chips-bg-right') : ''
          }`}
          type='button'
          onClick={handleReBetOrDoubleBet}
        >
          <span className={`icon-${betsModels.length ? 'double' : 'new-rebet'}`} />
        </button>
      </div>
    </div>
  );
});
